<template>
  <div class="content mpr-page">
    <!-- ============================================================
         TOOLBAR CARD: Bộ lọc + Tác vụ nhanh
         ============================================================ -->
    <div class="mpr-toolbar-card row-data">
      <!-- Vùng Bộ lọc -->
      <div class="mpr-toolbar-section mpr-toolbar-section--filter">
        <div class="mpr-card-head">
          <div>
            <p class="mpr-card-title">Bộ lọc tìm kiếm</p>
            <p class="mpr-card-subtitle">
              Tìm nhanh khoản thu theo tên, loại, phạm vi và trạng thái.
            </p>
          </div>
        </div>

        <div class="mpr-filter-grid">
          <!-- Lọc Loại: Thu / Chi -->
          <el-select
            v-model="searchRequest.category"
            placeholder="Loại khoản"
            clearable
            class="mpr-filter-control"
            @change="handleSearch"
          >
            <el-option label="Thu" value="IN" />
            <el-option label="Hoàn" value="OUT" />
          </el-select>
          <!-- Tìm theo tên -->
          <el-input
              v-model="searchRequest.keyword"
              placeholder="Nhập tên khoản thu..."
              clearable
              class="mpr-search-input"
              @keyup.enter.native="handleSearch"
              @clear="handleSearch"
          >
            <template #append>
              <el-button icon="el-icon-search" @click="handleSearch" />
            </template>
          </el-input>
        </div>
      </div>

      <!-- Đường kẻ ngăn cách -->
      <div class="mpr-toolbar-divider" />

      <!-- Vùng Tác vụ nhanh -->
      <div class="mpr-toolbar-section mpr-toolbar-section--action">
        <div class="mpr-card-head mpr-card-head--compact">
          <div>
            <p class="mpr-card-title">Tác vụ nhanh</p>
            <p class="mpr-card-subtitle">
              Thêm mới khoản dùng để tính toán vào hệ thống.
            </p>
          </div>
        </div>
        <div class="mpr-action-group">
          <el-button
            type="success"
            class="mpr-action-button mpr-action-button--primary"
            @click="openCreateDialog"
          >
            <i class="el-icon-plus" />
            Thêm mới
          </el-button>
        </div>
      </div>
    </div>

    <!-- ============================================================
         TABLE CARD: Danh sách khoản phụ
         ============================================================ -->
    <div class="mpr-table-card row-data">
      <!-- Header bảng -->
      <div class="mpr-card-head mpr-table-head">
        <div>
          <p class="mpr-card-title">Danh sách khoản phụ</p>
          <p class="mpr-card-subtitle">
            Quản lý toàn bộ khoản dùng để tính toán: đơn giá, thuế, giảm giá và điểm danh.
          </p>
        </div>
        <!-- Summary pill: hiện số bản ghi -->
<!--        <div class="mpr-summary-pill">-->
<!--          <strong>{{ principalRevenueList.length }}</strong>-->
<!--          <span>/ {{ pagination.total }} bản ghi</span>-->
<!--        </div>-->
      </div>

      <!-- Bảng dữ liệu -->
      <div class="mpr-table-wrapper">
        <el-table
          v-loading="tableLoading"
          :data="principalRevenueList"
          border
          class="sk-table"
          highlight-current-row
          :max-height="$tableMaxHeightSmall"
        >
          <!-- STT -->
          <el-table-column
            label="STT"
            type="index"
            width="55"
            align="center"
            :index="indexMethod"
          />

          <!-- Tên khoản thu -->
          <el-table-column label="Tên khoản thu" prop="name" min-width="200" />

          <!-- Mô tả (hiển thị tối đa 2 dòng, có Xem thêm nếu dài) -->
          <el-table-column label="Mô tả" min-width="200">
            <template slot-scope="{ row }">
              <div>
                <div :class="['mpr-desc', { expanded: isDescriptionExpanded(row.id) }]">{{ row.description || '—' }}</div>
                <div v-if="showDescriptionToggle(row.description)" class="mpr-desc-toggle">
                  <a href="#" @click.prevent="toggleDescription(row.id)">{{ isDescriptionExpanded(row.id) ? 'Thu gọn' : 'Xem thêm' }}</a>
                </div>
              </div>
            </template>
          </el-table-column>

          <!-- Loại (Thu/Hoàn) -->
          <el-table-column label="Loại" width="85" align="center">
            <template slot-scope="{ row }">
              <el-tag
                :type="row.category === 'IN' ? 'success' : 'danger'"
                size="mini"
                effect="light"
              >
                {{ row.category === "IN" ? "Thu" : "Hoàn" }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Đơn giá -->
          <el-table-column label="Đơn giá" width="145" align="right">
            <template slot-scope="{ row }">
              <span class="mpr-money">{{ formatMoney(row.price) }}</span>
            </template>
          </el-table-column>

          <!-- Đơn vị -->
          <el-table-column label="Đơn vị" prop="unit" width="90" align="center" />

          <!-- Số lượng-->
          <el-table-column label="Số lượng" width="90" align="center">
            <template slot-scope="{ row }">
              {{ formatQuantity(row.quantity) }}
            </template>
          </el-table-column>

          <!-- Giảm giá -->
          <el-table-column label="Giảm giá" width="150" align="center">
            <template slot-scope="{ row }">
              <i
                  :class="row.discount ? 'el-icon-circle-check' : 'el-icon-close'"
                  :style="{ color: row.discount ? '#16a34a' : '#dc2626', fontSize: '18px' }"
              />
            </template>
          </el-table-column>

          <!-- Áp dụng điểm danh -->
          <el-table-column label="Áp dụng điểm danh" width="150" align="center">
            <template slot-scope="{ row }">
              <i
                :class="row.attendance ? 'el-icon-circle-check' : 'el-icon-close'"
                :style="{ color: row.attendance ? '#16a34a' : '#dc2626', fontSize: '18px' }"
              />
            </template>
          </el-table-column>

          <!-- Thời gian áp dụng -->
          <el-table-column label="Thời gian áp dụng" width="150" align="center">
            <template slot-scope="{ row }">
              <el-tag size="mini" effect="plain" type="info">
                {{ appliedTimeTypeLabel(row.appliedTimeType) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- Thao tác -->
          <el-table-column label="Thao tác" width="120" align="center" fixed="right">
            <template slot-scope="{ row }">
              <el-tooltip content="Chỉnh sửa" placement="top">
                <el-button
                  type="primary"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  plain
                  @click="openEditDialog(row)"
                />
              </el-tooltip>
              <el-tooltip content="Xóa khoản thu" placement="top">
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  plain
                  class="ml-1"
                  @click="handleDelete(row.id)"
                />
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- Phân trang -->
      <div class="mpr-pagination">
        <el-pagination
          background
          :current-page.sync="pagination.page"
          :page-sizes="[25, 50, 100, 200]"
          :page-size.sync="pagination.size"
          :total="pagination.total"
          layout="sizes, prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </div>

    <!-- ============================================================
         DIALOG THÊM MỚI / CẬP NHẬT (component riêng)
         ============================================================ -->
    <principal-revenue-form-dialog ref="formDialog" @saved="fetchData" />
  </div>
</template>

<script>
import ManagingPrincipalRevenueService from "@/services/tutition_v3/ManagingPrincipalRevenueService";
import PrincipalRevenueFormDialog from "@/components/tutition_v3/dialog/PrincipalRevenueFormDialog.vue";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import { formatQuantity as formatQuantityValue } from "@/components/tutition_v3/utils/quantity";

export default {
  name: "ManagingPrincipalRevenue",
  components: { PrincipalRevenueFormDialog },

  data() {
    return {
      tableLoading: false,
      principalRevenueList: [],

      searchRequest: {
        keyword: "",
        category: "",
      },

      // page của FE bắt đầu từ 1, BE từ 0
      pagination: { page: 1, size: 25, total: 0 },
      // danh sách id đang mở rộng phần mô tả
      expandedDescriptionIds: [],
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    // ─── Helpers ──────────────────────────────────────────────────

    indexMethod(index) {
      return (this.pagination.page - 1) * this.pagination.size + index + 1;
    },

    formatMoney(value) {
      if (value === null || value === undefined || value === "") return "—";
      return Number(value).toLocaleString("vi-VN") + " ₫";
    },

    formatQuantity(value) {
      return formatQuantityValue(value);
    },

    appliedTimeTypeLabel(type) {
      return { MONTH: "Theo tháng", TIME_PERIOD: "Khoảng ngày", UNIT: "Theo đơn vị" }[type] || (type || "—");
    },

    // Mô tả: hỗ trợ xem thêm / thu gọn
    isDescriptionExpanded(id) {
      return this.expandedDescriptionIds.includes(id);
    },
    toggleDescription(id) {
      const idx = this.expandedDescriptionIds.indexOf(id);
      if (idx === -1) this.expandedDescriptionIds.push(id);
      else this.expandedDescriptionIds.splice(idx, 1);
    },
    showDescriptionToggle(desc) {
      if (!desc) return false;
      // xấp xỉ: nếu dài hơn 150 ký tự thì hiển thị toggle
      return String(desc).length > 150;
    },

    // ─── API ──────────────────────────────────────────────────────

    /**
     * Tải danh sách khoản .
     * Lưu ý: page FE (1-based) → trừ 1 trước khi gửi lên BE (0-based).
     */
    async fetchData() {
      this.tableLoading = true;
      try {
        const params = {
          ...this.searchRequest,
          page: this.pagination.page - 1,
          size: this.pagination.size,
        };
        // Loại bỏ key rỗng / null
        Object.keys(params).forEach((k) => {
          if (params[k] === "" || params[k] === null || params[k] === undefined) delete params[k];
        });

        const res = await ManagingPrincipalRevenueService.search(params);
        this.principalRevenueList = res.data.data|| [];
        this.pagination.total = res.data.total || 0;
       } catch (err) {
         NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Không thể tải danh sách khoản !");
       } finally {
        this.tableLoading = false;
      }
    },

    handleSearch() {
      this.pagination.page = 1;
      this.fetchData();
    },

    handleSizeChange(size) {
      this.pagination.size = size;
      this.pagination.page = 1;
      this.fetchData();
    },

    handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },

    /**
     * Xóa mềm – hiện this.$confirm trước khi gọi API DELETE.
     */
    async handleDelete(id) {
      try {
        await this.$confirm(
          "Bạn có chắc chắn muốn xóa khoản thu này? Thao tác không thể hoàn tác.",
          "Xác nhận xóa",
          { confirmButtonText: "Xóa", cancelButtonText: "Hủy", type: "warning" }
        );
      } catch { return; }

       try {
         const res = await ManagingPrincipalRevenueService.remove(id);
         NotifyMessage.leftCornerNotificationSuccess(res.data.message || "Xóa khoản dùng để tính toán thành công!");
         this.fetchData();
       } catch (err) {
         NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Xóa khoản dùng để tính toán thất bại!");
       }
    },


    // ─── Mở dialog (ủy quyền cho child qua $refs) ─────────────────

    openCreateDialog() {
      this.$refs.formDialog.openForCreate();
    },

    openEditDialog(row) {
      this.$refs.formDialog.openForEdit(row.id);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-table.scss";

/* ===================================================
   Trang quản lý khoản dùng để tính toán – MPR Page Layout
   Tham khảo phong cách Employee.vue
   =================================================== */

.mpr-page {
  padding: 4px 0 16px;

  .row-data {
    margin-bottom: 20px;
  }
}

/* ─── Toolbar card ─────────────────────────────────── */
.mpr-toolbar-card {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 18px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
}

.mpr-toolbar-section {
  min-width: 0;
}

.mpr-toolbar-section--filter {
  flex: 2;
}

.mpr-toolbar-section--action {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.mpr-toolbar-divider {
  width: 1px;
  align-self: stretch;
  background: #e2e8f0;
  flex-shrink: 0;
  margin: 0 4px;
}

/* ─── Table card ───────────────────────────────────── */
.mpr-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 18px 18px 14px;
}

/* ─── Card head (dùng cả 2 card) ─────────────────── */
.mpr-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.mpr-card-head--compact {
  margin-bottom: 14px;
}

.mpr-table-head {
  align-items: center;
}

.mpr-card-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

.mpr-card-subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #64748b;
}

/* ─── Bộ lọc ──────────────────────────────────────── */
.mpr-filter-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}

.mpr-search-input {
  width: 280px;
}

.mpr-filter-control {
  width: 160px;
}

/* ─── Tác vụ nhanh ────────────────────────────────── */
.mpr-action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.mpr-action-button {
  min-width: 130px;
  font-weight: 600;
}

.mpr-action-button--primary {
  box-shadow: 0 6px 16px rgba(34, 197, 94, 0.2);
}

/* ─── Summary pill ────────────────────────────────── */
.mpr-summary-pill {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
  padding: 8px 16px;
  border-radius: 999px;
  background: #eff6ff;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;

  strong {
    font-size: 18px;
    line-height: 1;
  }
}

/* ─── Bảng ────────────────────────────────────────── */
.mpr-table-wrapper {
  border-radius: 14px;
  overflow: hidden;
}

/* Tiền tệ trong bảng */
.mpr-money {
  font-variant-numeric: tabular-nums;
  color: #475569;
  font-size: 13px;
}

.mpr-money--highlight {
  color: #1d4ed8;
  font-weight: 600;
}

/* Status icon (V / X) — no border, larger and bold */
.mpr-status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.15s ease, transform 0.08s ease;
  font-size: 18px;
}
.mpr-status-icon i {
  font-size: 18px;
  line-height: 1;
}
.mpr-status-icon--active {
  color: #16a34a; /* green */
  background: rgba(22,163,74,0.06);
}
.mpr-status-icon--inactive {
  color: #dc2626; /* red */
  background: rgba(220,38,38,0.06);
}
.mpr-status-icon:active {
  transform: scale(0.98);
}

/* TÙY CHỈNH TIÊU ĐỀ CỘT: giống style Employee.vue - nền xanh đậm, chữ trắng */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important; /* xanh hệ thống */
  color: #ffffff !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
}

/deep/ .sk-table thead tr {
  height: 56px;
}

/* Giữ style body trắng */
/deep/ .sk-table tbody td {
  background: #ffffff;
}

/* ─── Phân trang ──────────────────────────────────── */
.mpr-pagination {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

/* ─── Input / Button bo góc ─────────────────────────── */
/deep/ .mpr-page .el-input__inner,
/deep/ .mpr-page .el-select .el-input__inner {
  border-radius: 10px;
}

/deep/ .mpr-page .el-button {
  border-radius: 10px;
}

/deep/ .mpr-page .el-input-group__append .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

/* ─── Responsive ──────────────────────────────────── */
@media (max-width: 1100px) {
  .mpr-toolbar-card {
    flex-direction: column;
    align-items: stretch;
  }

  .mpr-toolbar-divider {
    width: 100%;
    height: 1px;
    margin: 4px 0;
  }

  .mpr-table-head {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media (max-width: 768px) {
  .mpr-filter-grid,
  .mpr-action-group {
    flex-direction: column;
    align-items: stretch;
  }

  .mpr-search-input,
  .mpr-filter-control,
  .mpr-action-button {
    width: 100%;
  }

  .mpr-summary-pill {
    width: 100%;
    justify-content: center;
  }
}

/* Mô tả trong bảng: clamp 2 dòng, show toggle */
.mpr-desc {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.mpr-desc.expanded {
  -webkit-line-clamp: unset;
  overflow: visible;
}
.mpr-desc-toggle {
  margin-top: 6px;
}
.mpr-desc-toggle a { color: #2563eb; cursor: pointer; font-size: 13px; }
</style>
